var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 24.4061H25C26.6569 24.4061 28 23.063 28 21.4061V9.66699C28 8.01014 26.6569 6.66699 25 6.66699H7C5.34315 6.66699 4 8.01014 4 9.667V21.4061C4 23.063 5.34315 24.4061 7 24.4061Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.16699L16 14.917L27.25 8.16699M7 24.4061C5.34315 24.4061 4 23.063 4 21.4061V9.66699C4 8.01014 5.34315 6.66699 7 6.66699H25C26.6569 6.66699 28 8.01014 28 9.66699V21.4061C28 23.063 26.6569 24.4061 25 24.4061H7Z",
    stroke: "#EEE1E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.27ac95152918dcecb3e5f6755f01dab4.svg";
export { ForwardRef as ReactComponent };